import { apiMutate } from 'service/utils/mutation';
import { useDeliveryZoneMsToken } from 'hooks';
import { DeleteDeliveryZoneInput, DeleteDeliveryZonePayload } from '../../types/generated';
import { deleteDeliveryZoneMutation } from '../../mutations';

type useDeleteDeliveryZoneType = () => ({
  input,
}: {
  input?: DeleteDeliveryZoneInput;
}) => Promise<void | Partial<DeleteDeliveryZonePayload> | { hasError: boolean }>;

const useDeleteDeliveryZone: useDeleteDeliveryZoneType = () => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();
  return input =>
    apiMutate({
      mutation: deleteDeliveryZoneMutation,
      variables: { input },
      requestHeaders: { token: deliveryZoneMsToken },
      handler: (res: any) => res,
    });
};

export default useDeleteDeliveryZone;
